import React from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';
import { Field } from 'react-final-form';

import css from './FieldRadioButton.module.css';

const IconRadioButton = props => {
  const { checkedClassName, isCheckboxStyle } = props;
  return (
    <div>
      {isCheckboxStyle ? <>
        <svg className={css.checked} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.75 11C0.75 5.33908 5.33908 0.75 11 0.75C16.6609 0.75 21.25 5.33908 21.25 11C21.25 16.6609 16.6609 21.25 11 21.25C5.33908 21.25 0.75 16.6609 0.75 11Z" fill="#2F0F48" stroke="#2F0F48" strokeWidth="1.5" />
          <g clipPath="url(#clip0_5692_14543)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.364 6.40733C17.5515 6.59486 17.6568 6.84917 17.6568 7.11433C17.6568 7.3795 17.5515 7.6338 17.364 7.82133L9.86867 15.3167C9.76962 15.4157 9.65202 15.4943 9.52259 15.548C9.39316 15.6016 9.25444 15.6292 9.11434 15.6292C8.97424 15.6292 8.83552 15.6016 8.70609 15.548C8.57666 15.4943 8.45906 15.4157 8.36001 15.3167L4.63601 11.5933C4.5405 11.5011 4.46431 11.3907 4.41191 11.2687C4.3595 11.1467 4.33191 11.0155 4.33076 10.8827C4.3296 10.75 4.3549 10.6183 4.40519 10.4954C4.45547 10.3725 4.52972 10.2608 4.62361 10.1669C4.71751 10.073 4.82916 9.99879 4.95205 9.94851C5.07495 9.89823 5.20663 9.87293 5.33941 9.87408C5.47219 9.87523 5.60341 9.90282 5.72541 9.95523C5.84742 10.0076 5.95776 10.0838 6.05001 10.1793L9.11401 13.2433L15.9493 6.40733C16.0422 6.31441 16.1525 6.24069 16.2738 6.19039C16.3952 6.1401 16.5253 6.11421 16.6567 6.11421C16.7881 6.11421 16.9181 6.1401 17.0395 6.19039C17.1609 6.24069 17.2711 6.31441 17.364 6.40733Z" fill="white" />
          </g>
          <defs>
            <clipPath id="clip0_5692_14543">
              <rect width="16" height="16" fill="white" transform="translate(3 3)" />
            </clipPath>
          </defs>
        </svg>

        <svg style={{fill:"transparent"}} className={css.unchecked} width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11Z" fill="white" />
          <path d="M0.75 11C0.75 5.33908 5.33908 0.75 11 0.75C16.6609 0.75 21.25 5.33908 21.25 11C21.25 16.6609 16.6609 21.25 11 21.25C5.33908 21.25 0.75 16.6609 0.75 11Z" stroke="black" stroke-opacity="0.6" strokeWidth="1.5" />
        </svg>

      </> : (
        <svg className={props.className} width="14" height="14" xmlns="http://www.w3.org/2000/svg">
          <circle
            className={props.showAsRequired ? css.required : css.notChecked}
            cx="5"
            cy="19"
            r="6"
            transform="translate(2 -12)"
            strokeWidth="2"
            fill="none"
            fillRule="evenodd"
          />

          <g
            className={classNames(css.checked, checkedClassName || css.checkedStyle)}
            transform="translate(2 -12)"
            fill="none"
            fillRule="evenodd"
          >
            <circle strokeWidth="2" cx="5" cy="19" r="6" />
            <circle fill="#FFF" fillRule="nonzero" cx="5" cy="19" r="3" />
          </g>
        </svg>)}
    </div>
  );
};

IconRadioButton.defaultProps = { className: null };

IconRadioButton.propTypes = { className: string };

const FieldRadioButtonComponent = props => {
  const {
    rootClassName,
    className,
    svgClassName,
    checkedClassName,
    id,
    label,
    showAsRequired,
    isCheckboxStyle,
    ...rest
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const radioButtonProps = {
    id,
    className: css.input,
    component: 'input',
    type: 'radio',
    ...rest,
  };

  return (
    <span className={classes}>
      <Field {...radioButtonProps} />
      <label htmlFor={id} className={css.label}>
        <span className={css.radioButtonWrapper}>
          <IconRadioButton
            className={svgClassName}
            checkedClassName={checkedClassName}
            showAsRequired={showAsRequired}
            isCheckboxStyle={isCheckboxStyle}
          />
        </span>
        <span className={css.text}>{label}</span>
      </label>
    </span>
  );
};

FieldRadioButtonComponent.defaultProps = {
  className: null,
  rootClassName: null,
  svgClassName: null,
  checkedClassName: null,
  label: null,
};

FieldRadioButtonComponent.propTypes = {
  className: string,
  rootClassName: string,
  svgClassName: string,
  checkedClassName: string,

  // Id is needed to connect the label with input.
  id: string.isRequired,
  label: node,

  // Name groups several RadioButtones to an array of selected values
  name: string.isRequired,

  // RadioButton needs a value that is passed forward when user checks the RadioButton
  value: string.isRequired,
};

export default FieldRadioButtonComponent;
